/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

export const splitOccupancyByRoom = (occupancy: string): string[] => {
  if (!occupancy) {
    return [];
  }

  const segments: string[] = [];
  let current = '';
  let parenthesesDepth = 0;

  for (const char of occupancy) {
    if (char === '(') {
      parenthesesDepth += 1;
      current += char;
      continue;
    }

    if (char === ')') {
      parenthesesDepth = Math.max(0, parenthesesDepth - 1);
      current += char;
      continue;
    }

    if (char === ',' && parenthesesDepth === 0) {
      const trimmedSegment = current.trim();
      if (trimmedSegment) {
        segments.push(trimmedSegment);
      }
      current = '';
      continue;
    }

    current += char;
  }

  const trimmedLastSegment = current.trim();
  if (trimmedLastSegment) {
    segments.push(trimmedLastSegment);
  }

  return segments;
};
